import { useState, useEffect } from "react";
import DatosBasicosApi from "api/datosbasicosApi";

// Copia de los valores por defecto del catálogo del backend (api/datosbasicos/parametros.py).
// Solo se usan mientras cargan los parámetros o si la consulta falla.
export const PARAMETROS_POR_DEFECTO = {
  DIAS_GESTION_PROCESO: 60,
  "DIGITOS-CONS-PROCESO": 4,
  PORC_MIN_MORA: 30,
  MIN_ACREEDORES_MORA: 2,
  PORC_VOTACION_ACUERDO: 50,
  MIN_PLURALIDAD_ACREEDORES: 2,
  DIAS_PRORROGA_OPCIONES: [30, 90],
  DURACION_AUDIENCIA_MIN: 60,
  HORAS_ANTIREENVIO_CONVOCATORIA: 24,
  EMAIL_SOPORTE: "soporte@conciliadirecto.com",
  MEDIOS_PAGO: ["EFECTIVO", "BANCOLOMBIA", "AV VILLAS"],
  DIAS_COBRO_PLAN: [5, 10, 15, 20, 25],
};

// Caché compartida por toda la aplicación: una sola consulta por sesión
let solicitudParametros = null;

const cargarParametros = () => {
  if (!solicitudParametros) {
    solicitudParametros = DatosBasicosApi.fetchParametrosValores()
      .then((response) => ({ ...PARAMETROS_POR_DEFECTO, ...response.data }))
      .catch((error) => {
        console.error("Error al obtener los parámetros generales:", error);
        solicitudParametros = null;
        return PARAMETROS_POR_DEFECTO;
      });
  }
  return solicitudParametros;
};

// Para funciones fuera de componentes React (ej: validaciones asíncronas)
export const obtenerParametrosGenerales = () => cargarParametros();

// Se invoca al editar parámetros en Configuración para que la próxima lectura traiga los nuevos valores
export const invalidarParametrosGenerales = () => {
  solicitudParametros = null;
};

const useParametrosGenerales = () => {
  const [parametros, setParametros] = useState(PARAMETROS_POR_DEFECTO);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    let montado = true;
    cargarParametros().then((valores) => {
      if (montado) {
        setParametros(valores);
        setCargando(false);
      }
    });
    return () => {
      montado = false;
    };
  }, []);

  return { parametros, cargando };
};

export default useParametrosGenerales;
